export default __webpack_public_path__ + "static/media/shk.a5f2df99.mp3";